import { ONE_LINK_TEMPLATE_URL, STORAGE_KEYS } from '../../core/constants.js';
import { emitShortUrl } from '../../core/events.js';
import { readSession, writeSession } from '../../core/storage.js';

function getLongClickUrl() {
  return readSession(STORAGE_KEYS.clickUrl) || window._oblikClickURL || ONE_LINK_TEMPLATE_URL;
}

async function shorten(url) {
  try {
    const response = await fetch('/api/shorten', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ target: url, ttlDays: 90 })
    });
    const payload = await response.json();
    return payload?.short || url;
  } catch (_error) {
    return url;
  }
}

function apply(url) {
  document.querySelectorAll('a.js-af-cta').forEach((anchor) => {
    anchor.href = url;
    anchor.removeAttribute('target');
  });

  const copyInput = document.getElementById('copy-url');
  if (copyInput) copyInput.value = url;

  if (typeof window.renderQr === 'function') {
    window.renderQr('qr-container', url);
  }

  writeSession(STORAGE_KEYS.shortUrl, url);
  emitShortUrl(url);
}

export async function initShortLink() {
  const longUrl = getLongClickUrl();
  const finalUrl = await shorten(longUrl);
  apply(finalUrl);
}
